import styled from 'styled-components';
export const SearchInputWrapper = styled.div.withConfig({
  displayName: "Wrappers__SearchInputWrapper",
  componentId: "n8c9qp-0"
})(["display:flex;flex:0 1 550px;min-width:230px;"]);